import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  HStack,
  Image,
} from '@chakra-ui/react';

import { ReactComponent as ChevronRightIcon } from '../../assets/icons/chevron-right.svg';
import { tasksTabs } from './utils';

export const TasksLayout = () => {
  const location = useLocation();
  const { tabName = tasksTabs[0].link } = useParams();

  return (
    <Box mx="8" h="full" display="flex" flexDirection="column">
      <Breadcrumb separator={<ChevronRightIcon />}>
        <BreadcrumbItem>
          <HStack fontSize="xs" color="custom_blue.1">
            <Image src="/sidebar/tasks.svg" alt="roles icon" boxSize="4" />
            <Box>Tasks</Box>
          </HStack>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage={location.pathname.endsWith(tabName)}>
          <BreadcrumbLink
            as={Link}
            to={`/tasks/${tabName}`}
            fontSize="xs"
            color="custom_blue.1"
            textTransform="capitalize"
          >
            {tabName ? tabName : 'All'}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Outlet />
    </Box>
  );
};
